import React from 'react'
import PropTypes from 'prop-types'
import { TextAreaInput } from './styles'

const TextArea = ({ onChange, name, role, value, placeholder, id }) => {
  return (
    <TextAreaInput
      name={name}
      role={role}
      id={id}
      data-testid={id}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
    />
  )
}

TextArea.propTypes = {
  onChange: PropTypes.func,
  name: PropTypes.string,
  role: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  id: PropTypes.string,
}

export default TextArea
